export class SchoolScheduleEvent {
    public Id: number;
    public Title: string;
    public StartDate: Date;
    public FinishDate: Date;
    public ShiftId: number;
    public EventTypeId: number;
    public EventType: string;

    public constructor(){
        this.Id = -1;
        this.Title = '';
        this.StartDate = null;
        this.FinishDate = null;
        this.ShiftId = null;
        this.EventTypeId = null;
        this.EventType = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/event/dto/schoolScheduleEvent.ts